import '../text_filter_view.js.coffee'

Namespace 'Monitoring.Views.SocialContents.Filters'

class Monitoring.Views.SocialContents.Filters.GenericUserFilterView extends Monitoring.Views.SocialContents.Filters.TextFilterView
  extraTemplate: JST['backbone/templates/monitoring/filters/generic_user/generic_user_mode_filter']

  initialize: ({searchQuery, facet}) ->
    @searchQuery = searchQuery
    @facet = facet
    @title = I18n.t('monitoring.dashboard.filters.filter_names.users.name')
    @label = I18n.t('monitoring.dashboard.filters.filter_names.users.search_generic')

  render: =>
    super()
    @$el.find('#extra').html(@extraTemplate())
    @

  filter: (event) =>
    currentMode = @searchQuery.get('general_users_mode')
    selectedMode = @$el.find('input[name=user-mode]:checked').val()

    @searchQuery.resetField('general_users') unless currentMode == selectedMode
    @searchQuery.set('general_users_mode', selectedMode)

    super(event)

  _addValue: (value) =>
    @searchQuery.addGeneralUser(value)
